import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, dynamicFormType, rowConfig, usedFileType }) => {
    return {
      name,
      type: formType,
      label: fieldName,
      placeholder,
      validation,
      className,
      hidden,
      dynamicFormType,
      usedFileType
    };
  });
};


let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    fields = {
      agencies: mapFields(data?.agencies || []),
      airlines: mapFields(data?.airlines || []),
      cargo: mapFields(data?.cargo || []),
      groundHandlers: mapFields(data?.groundHandlers ||[]),
      groundHandlersPageHeading: mapFields(data?.groundHandlersPageHeading || []),
      cargoPageHeading: mapFields(data?.cargoPageHeading || []),
      airlinesPageHeading: mapFields(data?.airlinesPageHeading || []),
      agenciesPageHeading: mapFields(data?.agenciesPageHeading ||[]),
      agenciesNextPage: mapFields(data?.agenciesNextPage || []),
      airlinesNextPage: mapFields(data?.airlinesNextPage || []),
      cargoNextPage: mapFields(data?.cargoNextPage || []),
      groundHandlersNextPage: mapFields(data?.groundHandlersNextPage || [])
    };
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
